import { Button } from "@component/button";
import { TypeIcon, CircleDotIcon, ThumbsUpIcon } from "lucide-react";

interface QuestionType {
    id: string;
    label: string;
    icon: React.ReactNode;
}

interface InlineQuestionTypeSelectorProps {
    onSelectType: (typeId: string) => void;
    onCancel: () => void;
}

const questionTypes: QuestionType[] = [
    {
        id: "text",
        label: "Short Answer",
        icon: <TypeIcon className="h-5 w-5" />,
    },
    {
        id: "choice",
        label: "Multiple Choice",
        icon: <CircleDotIcon className="h-5 w-5" />,
    },
    {
        id: "rating",
        label: "Rating Scale",
        icon: <ThumbsUpIcon className="h-5 w-5" />,
    },
];

export default function InlineQuestionTypeSelector({
    onSelectType,
    onCancel,
}: InlineQuestionTypeSelectorProps) {
    return (
        <div className="py-4 space-y-3 flex justify-center">
            <div className="inline-grid grid-cols-3 gap-3">
                {questionTypes.map((type) => (
                    <Button
                        key={type.id}
                        variant="outline"
                        onClick={() => onSelectType(type.id)}
                        className="h-auto py-3 px-4 flex flex-col items-center justify-center gap-2 border-2 border-blue-600 hover:bg-blue-50 hover:border-blue-700 transition-colors text-blue-700 hover:text-blue-800 font-medium"
                    >
                        <div className="text-blue-600">{type.icon}</div>
                        <span>{type.label}</span>
                    </Button>
                ))}
            </div>
        </div>
    );
}
